module.exports = __webpack_public_path__ + "img/489-fbae1d.png";